import { render, staticRenderFns } from "./GoodsSwimWearView.vue?vue&type=template&id=3740b1d5&"
import script from "./GoodsSwimWearView.vue?vue&type=script&lang=js&"
export * from "./GoodsSwimWearView.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSwimWearView.vue?vue&type=style&index=0&id=3740b1d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports